




































































import { Component, Watch } from "@zoovu/runner-browser-api";
import { FileUploadQuestionView } from "@zoovu/runner-web-design-base";

@Component
export default class FileUploadQuestionViewExtended extends FileUploadQuestionView {
  interval: ReturnType<typeof setInterval> = null;

  statusBar = 0;

  @Watch("statusBar")
  onPropertyChanged(value: number): void {
    if (value === 100) {
      clearInterval(this.interval);
    }
  }

  // returns the bytes formatted in KB, MB, or GB
  getFormattedFileSize = (bytes: number): string => {
    if (bytes === 0) {
      return "0.00 B";
    }
    // get the index (and the max power) into the units abbreviation string " KMGTP" e.g: 0=B 1=KB, 2=MB...
    const e = Math.floor(Math.log(bytes) / Math.log(1024));
    // with e variable, we know what is the max power to divide the file size
    return `${(bytes / 1024 ** e).toFixed(2)} ${" KMGTP".charAt(e)}B`;
  };

  setBarStatus(): void {
    this.interval = setInterval(() => {
      this.statusBar += 1;
    }, 10);
  }

  onChangeFileInput(event: Event): void {
    this.statusBar = 10;
    this.selectedFiles = this.fileUploadImages;
    this.fileUploadImages = Array.from(event.target.files).map((file) => {
      const URL = window.URL || window.webkitURL;
      let thumbnail = "";
      if (URL && URL.createObjectURL) {
        thumbnail = URL.createObjectURL(file);
      }
      return {
        file,
        thumbnail,
      };
    });

    if (event.target.files.length) {
      this.selectedFiles = this.fileUploadImages;
      this.validateFiles();
      this.setQuestionSelection();
    } else {
      this.fileUploadImages = this.selectedFiles;
    }
    this.setBarStatus();
  }
}
